import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button, Dropdown, Input, Dimmer, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {ordersTypesCodes} from '../../../common/dictionaries/accessories';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ConfirmationModal from './modal/confirmation';
import Detail from './detail';

const ordersTypesOptions = [
  {'text': 'Todos', 'value': 'ALL'},
  {'text': 'Accesorios', 'value': ordersTypesCodes.accessories},
  {'text': 'Hunter', 'value': ordersTypesCodes.hunter},
];

const INITIAL_STATE = {
  'showTable': false,
  'commercialOrderFilter': '',
  'orderTypeFilter': 'ALL',
};

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleInvoiceClick = this.handleInvoiceClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.AccessoriesInvoicing, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  handleClearClick() {
    this.setState(INITIAL_STATE);
  }

  handleSearchClick() {
    this.setState({'showTable': true});

    const {commercialOrderFilter} = this.state;
    this.props.fetchOrdersByCommercialOrder(commercialOrderFilter, this.getParameters());
  }

  getParameters() {
    const {orderTypeFilter} = this.state;
    if (orderTypeFilter === 'ALL') {
      return {};
    }
    return {'orderType': orderTypeFilter};
  }
  getInvoicingType = () => {
    const {orders} = this.props;
    return orders.every((x) => x.anticipatedInvoice === 'S') ? 'ANTICIPADA' : 'NORMAL';
  }

  handleInvoiceClick(agency) {
    const {commercialOrderFilter} = this.state;
    const parameters = this.getParameters();
    this.props.createAccessoriesInvoice(commercialOrderFilter, parameters, {agency});
  }

  onChangeValues(value, field) {
    const {showTable} = this.state;
    const newState = {
      [field]: value.toUpperCase(),
    };
    if (showTable) {
      newState.showTable = false;
    }
    this.setState(newState);
  }

  renderFiltersSection() {
    const {loading, processingInvoice, dealerInfo} = this.props;
    const {showTable, commercialOrderFilter, orderTypeFilter} = this.state;

    return (
      <Grid>
        <Grid.Row textAlign='left'>
          <Grid.Column width={1}>
            <h4>Orden Comercial:</h4>
          </Grid.Column>
          <Grid.Column width={2}>
            <Input
              value={commercialOrderFilter}
              type='number'
              disabled={loading || processingInvoice}
              onChange={(e, {value}) => this.onChangeValues(value, 'commercialOrderFilter')}
              placeholder='Order'
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <h4>Tipo Orden:</h4>
          </Grid.Column>
          <Grid.Column width={2}>
            <Dropdown selection
              options={ordersTypesOptions}
              value={orderTypeFilter}
              disabled={loading || processingInvoice}
              onChange={(e, {value}) => this.onChangeValues(value, 'orderTypeFilter')}
              placeholder='Tipo Orden'
              noResultsMessage='Tipo no encontrada'
            />
          </Grid.Column>
          <Grid.Column width={2}>
            {showTable && <h4 style={{'textAlign': 'right'}}>Facturar a:</h4> }
          </Grid.Column>
          <Grid.Column width={3}>
            {showTable && dealerInfo.name}
          </Grid.Column>
          <Grid.Column width={2}>
            {showTable && <h4>Tipo de Facturación:</h4> }
          </Grid.Column>
          <Grid.Column width={2}>
            {showTable && this.getInvoicingType()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const {loading, processingInvoice, orders, dealerInfo, agencies} = this.props;
    const {showTable, commercialOrderFilter} = this.state;

    return (
      <div className='accessories-invoicing'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Facturación de Accesorios</h2>
              <div className='title-bar-actions'>
                <Button
                  secondary
                  disabled={loading || processingInvoice}
                  onClick={this.handleClearClick}
                >
                  Limpiar
                </Button>
                <Button
                  primary
                  disabled={
                    !commercialOrderFilter || loading || processingInvoice
                  }
                  onClick={this.handleSearchClick}
                >
                  Buscar
                </Button>
                <ConfirmationModal
                  dealerInfo={dealerInfo}
                  agencies={agencies}
                  commercialOrder={commercialOrderFilter}
                  disabled={!showTable || loading || processingInvoice}
                  onInvoiceClick={this.handleInvoiceClick}
                />
              </div>
            </div>
            <div className='filters-section'>{this.renderFiltersSection()}</div>
          </div>
        </Card>

        {showTable && <Detail loading={loading} orders={orders} />}

        {processingInvoice && (
          <Dimmer active inverted>
            <Loader inverted content='Procesando...' />
          </Dimmer>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.accessoriesInvoicing.loading,
    'orders': state.accessoriesInvoicing.orders,
    'agencies': state.accessoriesInvoicing.agencies,
    'dealerInfo': state.accessoriesInvoicing.dealerInfo,
    'processingInvoice': state.accessoriesInvoicing.invoicing,
    'permissions': state.session.permissions,
  };
};

const {
  fetchOrdersByCommercialOrder,
  createAccessoriesInvoice,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchOrdersByCommercialOrder,
  createAccessoriesInvoice,
  navigateTo,
})(Index);
